import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ApiError } from "./api/client";
import { router } from "./router";
import "./index.css";

// Audit a11y axe-core en développement uniquement (S3-11).
// L'import dynamique garantit que le bundle production ne contient PAS
// axe-core (vérifié via `npm run build` → aucune trace dans `dist/`).
if (import.meta.env.DEV) {
  void import("@axe-core/react").then(({ default: axe }) => {
    axe(React, ReactDOM, 1000);
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Bêta privée : pas de re-fetch agressif.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      // Ne jamais re-tenter un 4xx : déterministe (404/401/403/409/422…),
      // re-tenter ne fait que doubler le bruit console sans rien changer. On
      // garde 1 retry pour les transitoires (5xx, réseau → `ApiError.status`
      // 0 ou ≥ 500).
      retry: (failureCount, error) => {
        if (
          error instanceof ApiError &&
          error.status >= 400 &&
          error.status < 500
        ) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Élément racine #root introuvable dans index.html.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
